module.exports = __webpack_public_path__ + "static/formikIcon-c5c6e683d05c1b097511c08f2c71f49b.png";